import { Button } from "../ui/button";
import { StatusChip } from "./ShelfChips";
import { Pencil, Trash2 } from "lucide-react";

export const AdditionRow = ({ item, busy, onEdit, onDelete }) => (
  <div
    className="flex flex-wrap items-center gap-4 rounded-xl border border-border bg-card p-4"
    data-testid={`addition-row-${item.id}`}
  >
    <div className="min-w-0 flex-1">
      <div className="flex items-center gap-2 flex-wrap">
        <p className="font-semibold break-words">
                        {item.client_id && (
                          <span className="font-mono text-muted-foreground mr-2">{item.client_id}</span>
                        )}
                        {item.client_name}
                      </p>
        <StatusChip value={item.status} />
      </div>
      <p className="text-xs text-muted-foreground font-mono mt-0.5">
        {item.work_label}
        {item.due_date ? ` · due ${item.due_date}` : ""}
        {item.claimed_by_name ? ` · with ${item.claimed_by_name}` : ""}
      </p>
    </div>
    {item.can_manage && (
      <div className="flex items-center gap-2">
        <Button size="sm" variant="outline" disabled={busy} onClick={() => onEdit(item)} data-testid={`addition-edit-${item.id}`}>
          <Pencil size={13} />
        </Button>
        <Button
          size="sm"
          variant="outline"
          className="text-destructive border-destructive/30 hover:bg-destructive/10"
          disabled={busy}
          onClick={() => onDelete(item)}
          data-testid={`addition-delete-${item.id}`}
        >
          <Trash2 size={13} />
        </Button>
      </div>
    )}
  </div>
);
